// src/features/messages/components/MessageTime.jsx
import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import LocalizedDateDistance, { parseUTCToLocalTimezone, getDateLocale } from '../../../i18n/LocalizedDateDistance';

/** "5 minutes ago", with the exact time on hover */
export default function MessageTime({ date, variant = 'caption', sx }) {
  const { i18n } = useTranslation();
  if (!date) return null;
  const exact = format(parseUTCToLocalTimezone(date, i18n.language), 'd. MMM yyyy HH:mm', {
    locale: getDateLocale(i18n.language),
  });

  return (
    <Tooltip title={exact}>
      <Typography variant={variant} color="text.secondary" component="span" sx={{ whiteSpace: 'nowrap', ...sx }}>
        <LocalizedDateDistance date={date} />
      </Typography>
    </Tooltip>
  );
}
